// @flow

import { startRequest, finishRequest } from "@store/utils";
import type { EmployeesState } from "@modules/employee/reducer";
import type { SavedReport } from "@modules/employee/reducer/user-account-details/types";

export const setLoading = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...startRequest(state.employee.userAccount),
    },
  },
});

export const setLoaded = (state: EmployeesState) => () => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
    },
  },
});

export const onToggleEditAccessLevelModal = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...state.employee.userAccount,
      modals: {
        ...state.employee.userAccount.modals,
        editAccessLevel: {
          ...state.employee.userAccount.modals.editAccessLevel,
          visible: payload,
        },
      },
    },
  },
});

export const onToggleEditResetPasswordModal = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...state.employee.userAccount,
      modals: {
        ...state.employee.userAccount.modals,
        editResetPassword: {
          ...state.employee.userAccount.modals.editResetPassword,
          visible: payload,
        },
      },
    },
  },
});

export const onToggleConfirmResetPasswordModal = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...state.employee.userAccount,
      modals: {
        ...state.employee.userAccount.modals,
        confirmResetPassword: {
          ...state.employee.userAccount.modals.confirmResetPassword,
          visible: payload,
        },
      },
    },
  },
});

export const onGetUserRecentLoginsSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
      recentLogins: payload,
    },
  },
});

export const onGetUserRecentLoginsError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
      error: payload,
    },
  },
});

export const onGetUserAccountChangelogSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...state.employee.userAccount,
      changelog: payload,
      requestsInProgress:
        state.employee.userAccount.requestsInProgress > 0
          ? --state.employee.userAccount.requestsInProgress
          : 0,
    },
  },
});

export const onGetUserAccountChangelogError = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
      error: payload,
    },
  },
});

export const onGetAccessLevelSchemaSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    accessLeveSchema: payload,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
    },
  },
});

export const onGetAccessLevelValueSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    accessLevel: payload,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
    },
  },
});

export const onUpdateAccessLevelSuccess = (state: EmployeesState) => ({ payload }: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    accessLevel: payload,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
    },
  },
});

export const onGetUserAccountAssignmentsSuccess = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
      assignments: payload,
    },
  },
});

export const onGetUserAccountAssignmentsError = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
  employee: {
    ...state.employee,
    userAccount: {
      ...finishRequest(state.employee.userAccount),
    },
  },
});

export const onToggleUserAccountAssignmentsModal = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...state.employee.userAccount,
      modals: {
        ...state.employee.userAccount.modals,
        editAreaAccess: {
          ...state.employee.userAccount.modals.editAreaAccess,
          visible: payload,
        },
      },
    },
  },
});

export const onToggleUserAccountImpersonateModal = (state: EmployeesState) => ({
  payload,
}: Object) => ({
  ...state,
  employee: {
    ...state.employee,
    userAccount: {
      ...state.employee.userAccount,
      modals: {
        ...state.employee.userAccount.modals,
        impersonate: payload,
      },
    },
  },
});

export const onGetSavedReportsSuccess = (state: EmployeesState) => ({
  payload,
}: {
  payload: Array<SavedReport>,
}) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      userAccount: { ...state.employee.userAccount, savedReports: payload },
    },
  };
};

export const onGetReportLogDataSuccess = (state: EmployeesState) => ({ payload }: Object) => {
  return {
    ...state,
    employee: {
      ...state.employee,
      userAccount: {
        ...state.employee.userAccount,
        modals: {
          ...state.employee.userAccount.modals,
          logData: {
            ...state.employee.userAccount.modals.logData,
            data: payload,
          },
        },
      },
    },
  };
};

export const onToggleLogDataModal = (state: EmployeesState) => () => {
  return {
    ...state,
    employee: {
      ...state.employee,
      userAccount: {
        ...state.employee.userAccount,
        modals: {
          ...state.employee.userAccount.modals,
          logData: {
            ...state.employee.userAccount.modals.logData,
            visible: !state.employee.userAccount.modals.logData.visible,
          },
        },
      },
    },
  };
};
